/* global document */

import React from 'react';
import { render } from 'react-dom';
import Routes from './routes';
// import configureAxios from './axios';
// import configureStore from './store';
import store from './store';

import './assets/index.css';
// import './honeybadgerConfig';

// const store = configureStore();


// global.axios = configureAxios();

render(<Routes store={store} />, document.getElementById('root'));



// WEBPACK FOOTER //
// ./src/index.js